export default <TInit extends (...args: any[]) => void>(
  initialize: TInit,
  ...args: Parameters<TInit>
) => {
  initialize(...args);
};
